// Actions
export const BUDGET_FETCH  = '[Budget] Fetch'

// Mutations
export const BUDGET_META   = '[Budget] meta'
export const BUDGET_OBTAIN = '[Budget] obtain'
export const BUDGET_CLEAR  = '[Budget] clear'
export const BUDGET_SET_LOADING = '[Budget] set loading'
